export default __webpack_public_path__ + "static/media/Encantos_yellow_logo.c3fa3410.svg";